import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Swedish possessive form - handles names ending with 's', 'x', 'z'
 * Examples: "Emma" -> "Emmas", "Agnes" -> "Agnes", "Max" -> "Max"
 */
export function swedishPossessive(name: string): string {
  if (!name) return "";
  const lastChar = name.slice(-1).toLowerCase();
  // In Swedish, names ending with s, x, or z don't add another 's'
  if (lastChar === 's' || lastChar === 'x' || lastChar === 'z') {
    return name;
  }
  return `${name}s`;
}
